import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import '@/styles/index.scss' // global css
// import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import './icons' // icon

import './plugins/axios'
import './plugins/element.js'
import './plugins/common.js'
import './plugins/moment.js'
import './plugins/permission.js'
import './plugins/drag.js'
import './plugins/dayjs'
import './directives'
import './components'
import './plugins/echarts'

import Print from 'vue-print-nb'
Vue.use(Print)
Vue.prototype.$bus = new Vue();

Vue.config.productionTip = false
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
